import React, { useState, useEffect, useContext } from 'react'
import AdminContext from '../../StateContext/Application'
import { apiurl } from '../../../../path'
import { useLanguage } from '../../../../lang/langcontext/LanguageContext'
const ProjectList = () => {
      const { language, toggleLanguage, t } = useLanguage();
    const context = useContext(AdminContext)
    const { GetAllProjectList } = context
    const [project, setProjectList] = useState([])
    const [filteredBills, setFilteredBills] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedProposalYear, setSelectedProposalYear] = useState('');
    const [selectedGRAmount, setSelectedGRAmount] = useState('');

    const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
    const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

    const getProjectList = async () => {
        let data = await GetAllProjectList()
        console.log("data", data);

        setProjectList(data)
        setFilteredBills(data);
    }
    useEffect(() => {
        getProjectList()
    }, [])
    let projectList = []
    if (project.length > 0) {
        projectList = project
    }

    useEffect(() => {
        const lowerSearchTerm = searchTerm.toLowerCase();
        const filtered = project.filter((bill) =>
            Object.values(bill).some((val) =>
                (val || '').toString().toLowerCase().includes(lowerSearchTerm)
            )
        );
        setFilteredBills(filtered);
        setCurrentPage(1);
    }, [searchTerm, project]);


    useEffect(() => {
        let filtered = project;

        if (selectedProposalYear) {
            filtered = filtered.filter((bill) => bill.ProposalYear === selectedProposalYear);
        }

        if (selectedGRAmount) {
            filtered = filtered.filter((bill) => bill.GRAmount === selectedGRAmount);
        }

        setFilteredBills(filtered);
        setCurrentPage(1);
    }, [selectedProposalYear, selectedGRAmount, project]);

    const uniqueProposalYears = [...new Set(project.map((item) => item.ProposalYear))];
    const uniqueGRAmounts = selectedProposalYear
        ? [...new Set(project.filter((item) => item.ProposalYear === selectedProposalYear).map((item) => item.GRAmount))]
        : [];
    // return (

    //     <>
    //         <div className="col-12" style={{ backgroundColor: "#EFF3F8", height: "89vh", overflowX: "hidden", overflowY: "scroll" }}>
    //             <div className="col-11 m-auto">

    //                 <div className="col-12">
    //                     <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
    //                         {/* <h4 style={{ margin: "10px 0px" }}></h4> */}
    //                         <h5 className='my-auto fw-bold'>
    //                             <img src="/GR-Approval64.png" alt="Vendor Report" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
    //                             <span className='my-auto'>GR Report</span>
    //                         </h5>
    //                         {/* <input type="text" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)}
    //                         value={searchTerm}
    //                         style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} /> */}

    //                         <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
    //                             <img
    //                                 src="/Search32.png"
    //                                 alt="Search Icon"
    //                                 style={{
    //                                     position: "absolute",
    //                                     top: "50%",
    //                                     left: "10px",
    //                                     transform: "translateY(-50%)",
    //                                     width: "16px",
    //                                     height: "16px",
    //                                     opacity: 0.6
    //                                 }}
    //                             />
    //                             <input
    //                                 type="text"
    //                                 placeholder="Search Here"
    //                                 onChange={(e) => setSearchTerm(e.target.value)}
    //                                 value={searchTerm}
    //                                 style={{
    //                                     width: "100%",
    //                                     padding: "8px 12px 8px 32px", // left padding makes space for icon
    //                                     border: "1px solid #ccc",
    //                                     borderRadius: "8px",
    //                                     backgroundColor: "#f1f6fc",
    //                                     fontSize: "14px",
    //                                     color: "#333",
    //                                     boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
    //                                     outline: "none"
    //                                 }}
    //                             />
    //                         </div>
    //                     </div>

    //                     <div className="col-12 pb-5">
    //                         <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%",maxWidth:"100%",overflowX:"hidden" }}>
    //                             <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: 'scroll' }}>
    //                                 <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
    //                                     <thead>
    //                                         <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
    //                                             <th style={{ minWidth: "40px", padding: "8px" }}>Sr.No</th>
    //                                             <th style={{ minWidth: "120px", padding: "8px" }}>GR UID</th>
    //                                             <th style={{ minWidth: "100px", padding: "8px" }}>Head Code</th>
    //                                             <th style={{ minWidth: "100px", padding: "8px" }}>Proposal UID</th>
    //                                             <th style={{ minWidth: "100px", padding: "8px" }}>Approved Year</th>
    //                                             <th style={{ minWidth: "140px", padding: "8px" }}>Approved Amount</th>
    //                                             <th style={{ minWidth: "120px", padding: "8px" }}>Zilla Parishad</th>
    //                                             {/* <th style={{ padding: '8px' }}>Project Estimation Completion Date</th> */}
    //                                             <th style={{ minWidth: "100px", padding: "8px" }}>GR Amount</th>
    //                                             <th style={{ minWidth: "140px", padding: "8px" }}>GR Number</th>
    //                                             <th style={{ minWidth: "160px", padding: "8px" }}>GR Date</th>
    //                                             <th style={{ minWidth: "240px", padding: "8px" }}>GR Copy</th>
    //                                             <th style={{ minWidth: "160px", padding: "8px" }}>Date</th>
    //                                         </tr>
    //                                     </thead>
    //                                     <tbody>
    //                                         {currentBills?.length === 0 ? (
    //                                             <tr>
    //                                                 <td colSpan="20" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
    //                                                     No data available
    //                                                 </td>
    //                                             </tr>
    //                                         ) : (
    //                                             currentBills?.map((project, index) => {
    //                                                 const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
    //                                                 return (
    //                                                     <tr key={index} style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "500" }}>
    //                                                         <td>{(currentPage - 1) * billsPerPage + index + 1}</td>
    //                                                         <td style={{ padding: '8px' }}>{project.GRID}</td>
    //                                                         <td style={{ padding: '8px' }}>{project.HeadCode}</td>
    //                                                         <td style={{ padding: '8px' }}>{project.ProposalID}</td>
    //                                                         <td style={{ padding: '8px' }}>{project.ProposalYear}</td>
    //                                                         <td style={{ padding: '8px' }}>{project.ProposalAmount}</td>
    //                                                         <td style={{ padding: '8px' }}>{project.ZillaParishad}</td>
    //                                                         {/* <td style={{ padding: '8px' }}>{project.ProjectEstCompletionDate?.split('T')[0].replace(' ')}</td> */}
    //                                                         <td style={{ padding: '8px' }}>{project.GRAmount}</td>
    //                                                         {/* <td style={{ padding: '8px' }}>{project.GRDate?.split('T')[0].replace(' ')}</td>
    //                                         <td style={{ padding: '8px' }}><a href={`${apiurl}/ProjectDocsImages/${project.GRCopy}`} target='_blank'>{project.GRCopy}</a></td>
    //                                         <td style={{ padding: '8px' }}>{project.Date?.split('T')[0].replace(' ')}</td> */}
    //                                                         <td style={{ padding: '8px' }}>{project.GRNumber}</td>
    //                                                         <td style={{ padding: '8px' }}>{new Date(project.GRDate).toLocaleString()}</td>
    //                                                         <td style={{ padding: '8px' }}>{
    //                                                             project.GRCopy ? (
    //                                                                 <p className='my-auto'>
    //                                                                     <a href={`${apiurl}/ProjectDocsImages/${project.GRCopy}`} target='_blank'>{project.GRCopy}</a>
    //                                                                 </p>
    //                                                             ) : (
    //                                                                 <p className='my-auto bg-danger'>No File</p>
    //                                                             )
    //                                                         }
    //                                                         </td>
    //                                                         <td style={{ padding: '8px' }}>{new Date(project.Date).toLocaleString()}</td>
    //                                                     </tr>
    //                                                 );
    //                                             })
    //                                         )}
    //                                     </tbody>
    //                                 </table>
    //                             </div>

    //                             <div className='col-12 mt-4'>
    //                                 <div className="row">
    //                                     <div className='col-6'>
    //                                         <p className="text-gray-600" style={{ fontSize: "14px" }}>
    //                                             Showing {indexOfFirstBill + 1} to {Math.min(indexOfLastBill, filteredBills.length)} of {project.length} entries
    //                                         </p>
    //                                     </div>
    //                                     <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
    //                                         {/* First Page Button */}
    //                                         <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
    //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>
    //                                             &laquo;
    //                                         </button>
    //                                         {/* Previous Button */}
    //                                         <button
    //                                             onClick={() => setCurrentPage(currentPage - 1)}
    //                                             disabled={currentPage === 1}
    //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
    //                                             &lt;
    //                                         </button>

    //                                         <button
    //                                             style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
    //                                         </button>
    //                                         {/* Next Button */}
    //                                         <button
    //                                             onClick={() => setCurrentPage(currentPage + 1)}
    //                                             disabled={currentPage === totalPages}
    //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
    //                                             &gt;
    //                                         </button>
    //                                         {/* Last Page Button */}
    //                                         <button
    //                                             onClick={() => setCurrentPage(totalPages)}
    //                                             disabled={currentPage === totalPages}
    //                                             style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
    //                                             &raquo;
    //                                         </button>
    //                                     </div>
    //                                 </div>

    //                             </div>


    //                         </div>

    //                     </div>
    //                 </div>

    //             </div>
    //         </div>
    //     </>
    // )
      return (

        <>
            <div className="col-12" style={{ backgroundColor: "#EFF3F8", height: "89vh", overflowX: "hidden", overflowY: "scroll" }}>
                <div className="col-11 m-auto">

                    <div className="col-12">
                        <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            {/* <h4 style={{ margin: "10px 0px" }}></h4> */}
                            <h5 className='my-auto fw-bold'>
                                <img src="/GR-Approval64.png" alt="Vendor Report" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
                                <span className='my-auto'>{t("GR Report")}</span>
                            </h5>
                            {/* <input type="text" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)}
                            value={searchTerm}
                            style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} /> */}

                            <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
                                <img
                                    src="/Search32.png"
                                    alt="Search Icon"
                                    style={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "10px",
                                        transform: "translateY(-50%)",
                                        width: "16px",
                                        height: "16px",
                                        opacity: 0.6
                                    }}
                                />
                                <input
                                    type="text"
                                    placeholder={t("Search Here")}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    value={searchTerm}
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px 8px 32px", // left padding makes space for icon
                                        border: "1px solid #ccc",
                                        borderRadius: "8px",
                                        backgroundColor: "#f1f6fc",
                                        fontSize: "14px",
                                        color: "#333",
                                        boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                        outline: "none"
                                    }}
                                />
                            </div>
                        </div>

                        <div className="col-12 pb-5">
                            <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%",maxWidth:"100%",overflowX:"hidden" }}>
                                <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: 'scroll' }}>
                                    <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
                                                <th style={{ minWidth: "40px", padding: "8px" }}>{t("Sr.No")}</th>
                                                <th style={{ minWidth: "120px", padding: "8px" }}>{t("GR UID")}</th>
                                                <th style={{ minWidth: "100px", padding: "8px" }}>{t("Head Code")}</th>
                                                <th style={{ minWidth: "100px", padding: "8px" }}>{t("Proposal UID")}</th>
                                                <th style={{ minWidth: "100px", padding: "8px" }}>{t("Approved Year")}</th>
                                                <th style={{ minWidth: "140px", padding: "8px" }}>{t("Approved Amount")}</th>
                                                <th style={{ minWidth: "120px", padding: "8px" }}>{t("Zilla Parishad")}</th>
                                                {/* <th style={{ padding: '8px' }}>Project Estimation Completion Date</th> */}
                                                <th style={{ minWidth: "100px", padding: "8px" }}>{t("GR Amount")}</th>
                                                <th style={{ minWidth: "140px", padding: "8px" }}>{t("GR Number")}</th>
                                                <th style={{ minWidth: "160px", padding: "8px" }}>{t("GR Date")}</th>
                                                <th style={{ minWidth: "240px", padding: "8px" }}>{t("GR Copy")}</th>
                                                <th style={{ minWidth: "160px", padding: "8px" }}>{t("Date")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentBills?.length === 0 ? (
                                                <tr>
                                                    <td colSpan="20" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
                                                        {t("No data available")}
                                                    </td>
                                                </tr>
                                            ) : (
                                                currentBills?.map((project, index) => {
                                                    const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                                    return (
                                                        <tr key={index} style={{ backgroundColor: bgColor, fontSize: "12px", fontWeight: "500" }}>
                                                            <td>{(currentPage - 1) * billsPerPage + index + 1}</td>
                                                            <td style={{ padding: '8px' }}>{project.GRID}</td>
                                                            <td style={{ padding: '8px' }}>{project.HeadCode}</td>
                                                            <td style={{ padding: '8px' }}>{project.ProposalID}</td>
                                                            <td style={{ padding: '8px' }}>{project.ProposalYear}</td>
                                                            <td style={{ padding: '8px' }}>{project.ProposalAmount}</td>
                                                            <td style={{ padding: '8px' }}>{project.ZillaParishad}</td>
                                                            {/* <td style={{ padding: '8px' }}>{project.ProjectEstCompletionDate?.split('T')[0].replace(' ')}</td> */}
                                                            <td style={{ padding: '8px' }}>{project.GRAmount}</td>
                                                            {/* <td style={{ padding: '8px' }}>{project.GRDate?.split('T')[0].replace(' ')}</td>
                                            <td style={{ padding: '8px' }}><a href={`${apiurl}/ProjectDocsImages/${project.GRCopy}`} target='_blank'>{project.GRCopy}</a></td>
                                            <td style={{ padding: '8px' }}>{project.Date?.split('T')[0].replace(' ')}</td> */}
                                                            <td style={{ padding: '8px' }}>{project.GRNumber}</td>
                                                            <td style={{ padding: '8px' }}>{new Date(project.GRDate).toLocaleString()}</td>
                                                            <td style={{ padding: '8px' }}>{
                                                                project.GRCopy ? (
                                                                    <p className='my-auto'>
                                                                        <a href={`${apiurl}/ProjectDocsImages/${project.GRCopy}`} target='_blank'>{project.GRCopy}</a>
                                                                    </p>
                                                                ) : (
                                                                    <p className='my-auto bg-danger'>{t("No File")}</p>
                                                                )
                                                            }
                                                            </td>
                                                            <td style={{ padding: '8px' }}>{new Date(project.Date).toLocaleString()}</td>
                                                        </tr>
                                                    );
                                                })
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <div className='col-12 mt-4'>
                                    <div className="row">
                                        <div className='col-6'>
                                            <p className="text-gray-600" style={{ fontSize: "14px" }}>
                                                {t("Showing")} {indexOfFirstBill + 1} {t("to")} {Math.min(indexOfLastBill, filteredBills.length)} {t("of")} {project.length} {t("entries")}
                                            </p>
                                        </div>
                                        <div className='col-6' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
                                            {/* First Page Button */}
                                            <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', width: '2rem' }}>
                                                &laquo;
                                            </button>
                                            {/* Previous Button */}
                                            <button
                                                onClick={() => setCurrentPage(currentPage - 1)}
                                                disabled={currentPage === 1}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                                &lt;
                                            </button>

                                            <button
                                                style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '20px', width: '2.4rem', border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
                                            </button>
                                            {/* Next Button */}
                                            <button
                                                onClick={() => setCurrentPage(currentPage + 1)}
                                                disabled={currentPage === totalPages}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                                &gt;
                                            </button>
                                            {/* Last Page Button */}
                                            <button
                                                onClick={() => setCurrentPage(totalPages)}
                                                disabled={currentPage === totalPages}
                                                style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '20px', borderLeft: "none", width: '2rem' }}>
                                                &raquo;
                                            </button>
                                        </div>
                                    </div>

                                </div>


                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default ProjectList
